import { jsxs as r, jsx as l } from "react/jsx-runtime";
import { useState as s, useRef as b } from "react";
import { classes as m, areaCodePhoneNumberMask as M } from "../../utils/helpers.js";
import { s as t, C as V, A as $ } from "../../Form.module-DbpB9u1l.mjs";
function B({
  name: i,
  label: h = "",
  helpText: p = "",
  type: x = "text",
  width: _ = 100,
  showValidation: n = !0,
  ...v
}) {
  var u, d, f;
  const [y, C] = s(`${t["form-field__input"]}`), e = b(), [c, a] = s(""), [o, N] = s("clean"), g = `input-width--${_}`, k = () => {
    N("touched"), C(`${t["form-field__input"]} ${t["input--touched"]}`), e.current.type === "tel" && (e.current.value = M(e.current.value)), e.current.checkValidity() ? a("") : e.current.type === "email" ? a("Please enter a vaild email.") : e.current.type === "tel" ? a("Please match the requested format: (xxx) xxx-xxxx") : a(e.current.validationMessage);
  };
  return /* @__PURE__ */ r("label", { htmlFor: i, className: m([t["form-field"], t[g]]), children: [
    n && /* @__PURE__ */ r(
      "i",
      {
        className: m([
          t["form-field__icon"],
          (u = e.current) != null && u.validity.valid ? "" : t["form-field__icon--invalid"]
        ]),
        children: [
          ((d = e.current) == null ? void 0 : d.checkValidity()) && o === "touched" && /* @__PURE__ */ l(V, {}),
          !((f = e.current) != null && f.checkValidity()) && o === "touched" && /* @__PURE__ */ l($, {})
        ]
      }
    ),
    /* @__PURE__ */ r("span", { className: t["form-field__label"], children: [
      h,
      " ",
      /* @__PURE__ */ l("span", { className: t["form-field__label-help"], children: p })
    ] }),
    /* @__PURE__ */ l(
      "input",
      {
        className: y,
        name: i,
        id: i,
        type: x,
        ref: e,
        onBlur: () => {
          k();
        },
        ...v
      }
    ),
    c !== "" && n && /* @__PURE__ */ l("div", { className: t["form-field__error-message"], children: c })
  ] });
}
export {
  B as Input,
  B as default
};
